var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "article-list grid grid__base",
      on: { click: _vm.loadNext }
    },
    [
      _c(
        "div",
        { staticClass: "grid--container" },
        [
          _c(
            "div",
            { staticClass: "article-list--row grid--row" },
            [
              _vm._t("default"),
              _vm._v(" "),
              _vm._l(_vm.articleItems, function(item, idx) {
                return _c(
                  "a",
                  {
                    key: idx,
                    staticClass:
                      "article-list--col article-list--item grid--col",
                    attrs: { href: item.link.path }
                  },
                  [
                    _c(
                      "article-preview",
                      _vm._b({}, "article-preview", item, false)
                    )
                  ],
                  1
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "intersection-observer-component",
            { on: { "intersect-enter": _vm.onIntersectEnter } },
            [
              _vm.canLoadNext && _vm.fetchUrl
                ? _c("div", { staticClass: "article-list--row grid--row" }, [
                    _c(
                      "div",
                      { staticClass: "grid--col" },
                      [_vm.isLoading ? _c("dat-loader") : _vm._e()],
                      1
                    )
                  ])
                : _vm._e()
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b3acaa4a", { render: render, staticRenderFns: staticRenderFns })
  }
}